// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AccountContactPreferenceModel {
    static getAttributeTypeMap() {
        return AccountContactPreferenceModel.attributeTypeMap;
    }
}
AccountContactPreferenceModel.discriminator = undefined;
AccountContactPreferenceModel.additionalProperties = false;
AccountContactPreferenceModel.attributeTypeMap = [
    {
        "name": "contactInfoType",
        "baseName": "contactInfoType",
        "type": "ContactInformationType"
    },
    {
        "name": "setAllOthersToNotPreferred",
        "baseName": "setAllOthersToNotPreferred",
        "type": "boolean"
    },
    {
        "name": "isOptedIn",
        "baseName": "isOptedIn",
        "type": "boolean"
    },
    {
        "name": "isPreferred",
        "baseName": "isPreferred",
        "type": "boolean"
    },
];
//# sourceMappingURL=accountContactPreferenceModel.js.map